import { createReduxSlice } from '../../../redux/ReduxSlice'
import { State } from 'app/types/redux-types'
import { Offer } from 'app/types/types'

const initialState: State<Offer> = {
  data: {} as Offer,
  status: 'idle',
  error: null
}

const offerSlice = createReduxSlice({
  name: 'currentOffer',
  initialState,
  reducers: {
    setOfferData: (state, action) => {
      state.data = action.payload
      state.status = 'succeeded'
    },
    reset: () => initialState
  }
})

export const { setOfferData, reset: resetOffer } = offerSlice.actions
export default offerSlice.reducer
